module.exports = __webpack_public_path__ + "59ff72566ae47b9bf214e95c1ed13a4a.pdf";